import { AutoCompleteListProps } from "@equitable/equx";
import { getAdvisorCodes } from "@/common/utils/api";
import { isUserAuthenticated } from "@/common/utils/helpers";
import React, { createContext, useContext, useState } from "react";

export interface AdvisorCodeInfo {
  advisorCode: string;
  firstName: string;
  lastName: string;
}

export interface IAdvisorCodeInfoContext {
  advisorInfo: AdvisorCodeInfo[];
  advisorInfoAutoCompleteOptions: AutoCompleteListProps[];
  loadData: () => void;
  selectedAdvisorCode: string|null;
  setSelectedAdvisorCode: React.Dispatch<string | null>;
}

const AdvisorCodeInfoProvider = ({ children }: any) => {
  const [advisorInfo, setAdvisorInfo] = useState<AdvisorCodeInfo[] | null>(null);
  const [selectedAdvisorCode, setSelectedAdvisorCode] = useState<string|null>(null);

  const loadData = async () => {
    if (isUserAuthenticated() && advisorInfo == null) {
      setAdvisorInfo([]);
      const data = await getAdvisorCodes();
      setAdvisorInfo(data);
    }
  };

  const getAdvisorInfoAutoCompleteOptions = (): AutoCompleteListProps [] => {

    if (advisorInfo == null) {
      return [];
    }

    return advisorInfo.map(
      (info: AdvisorCodeInfo) =>
        ({
          label: `${info.advisorCode} - ${info.firstName || ""}  ${info.lastName || ""}`,
          value: `${info.advisorCode},${info.firstName || ""},${info.lastName || ""}`,
        } as AutoCompleteListProps)
    );
  };

  return (
    <AdvisorCodeInfoContext.Provider
      value={{
        get advisorInfo() {
          return advisorInfo ?? [];
        },
        get advisorInfoAutoCompleteOptions() {
          return getAdvisorInfoAutoCompleteOptions();
        },
        loadData,
        selectedAdvisorCode,
        setSelectedAdvisorCode
      }}
    >
      {children}
    </AdvisorCodeInfoContext.Provider>
  );
};

export const AdvisorCodeInfoContext = createContext<IAdvisorCodeInfoContext>(undefined!);
export const useAdvisorInfo = () => useContext(AdvisorCodeInfoContext);
export default AdvisorCodeInfoProvider;